import { api_instance } from "./api";

export const applyJobs = (payload) => {
  return api_instance.post("/apply_jobs.php", payload);
};
